import { Box, BoxProps } from '@chakra-ui/react';

/** The app's logo: a plain red dot. */
export const LogoDot = (props: BoxProps) => (
  <Box aria-hidden boxSize='20px' borderRadius='full' bg='red.500' flexShrink={0} {...props} />
);
